import React from 'react';
import './WhatIsGit.css';

function WhatIsGit() {
  return (
    <section id="que-es-git" className="what-is-git">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Pas 2</span>
          <h2 className="section-title">Git vs <span className="gold">GitHub</span> vs <span className="gold">GitLab</span></h2>
          <p className="section-desc">
            Es fonamental entendre la diferencia entre Git (l'eina) i les plataformes (GitHub, GitLab).
          </p>
        </div>

        {/* Comparison table */}
        <div className="comparison-table-wrapper">
          <table className="comparison-table">
            <thead>
              <tr>
                <th></th>
                <th>
                  <div className="th-content">
                    <div className="th-icon git-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M23.546 10.93L13.067.452a1.55 1.55 0 00-2.188 0L8.708 2.627l2.76 2.76a1.838 1.838 0 012.327 2.341l2.66 2.66a1.838 1.838 0 11-1.103 1.033l-2.483-2.483v6.534a1.838 1.838 0 11-1.512-.06V8.79a1.838 1.838 0 01-.998-2.41L7.636 3.656.45 10.842a1.55 1.55 0 000 2.188l10.48 10.477a1.55 1.55 0 002.186 0l10.43-10.39a1.55 1.55 0 000-2.187z"/></svg>
                    </div>
                    <span>Git</span>
                  </div>
                </th>
                <th>
                  <div className="th-content">
                    <div className="th-icon github-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/></svg>
                    </div>
                    <span>GitHub</span>
                  </div>
                </th>
                <th>
                  <div className="th-content">
                    <div className="th-icon gitlab-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"/></svg>
                    </div>
                    <span>GitLab</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="row-label">Que es?</td>
                <td>Sistema de <strong>control de versions</strong> (software local)</td>
                <td><strong>Plataforma web</strong> per allotjar repositoris Git</td>
                <td><strong>Plataforma web</strong> per allotjar repositoris Git</td>
              </tr>
              <tr>
                <td className="row-label">On s'executa?</td>
                <td>Al teu <strong>ordinador</strong> (terminal)</td>
                <td>Al <strong>nuvol</strong> (github.com)</td>
                <td>Al <strong>nuvol</strong> (gitlab.com) o <strong>self-hosted</strong></td>
              </tr>
              <tr>
                <td className="row-label">Creador</td>
                <td>Linus Torvalds (2005)</td>
                <td>GitHub Inc. (Microsoft)</td>
                <td>GitLab Inc.</td>
              </tr>
              <tr>
                <td className="row-label">Funcio principal</td>
                <td>Registrar canvis al codi</td>
                <td>Compartir codi + col·laborar</td>
                <td>Compartir codi + DevOps complet</td>
              </tr>
              <tr>
                <td className="row-label">CI/CD integrat</td>
                <td className="cell-no">No</td>
                <td className="cell-partial">Si (GitHub Actions)</td>
                <td className="cell-yes">Si (molt potent, integrat)</td>
              </tr>
              <tr>
                <td className="row-label">Repos privats gratis</td>
                <td className="cell-na">N/A</td>
                <td className="cell-yes">Si (il·limitats)</td>
                <td className="cell-yes">Si (il·limitats)</td>
              </tr>
              <tr>
                <td className="row-label">Self-hosting</td>
                <td className="cell-na">N/A</td>
                <td className="cell-partial">Si (Enterprise, de pagament)</td>
                <td className="cell-yes">Si (Community Edition gratis)</td>
              </tr>
              <tr>
                <td className="row-label">Popularitat</td>
                <td>Estandard mundial</td>
                <td>100M+ repositoris, #1 mondial</td>
                <td>30M+ usuaris, popular empreses/unis</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Key insight */}
        <div className="insight-cards">
          <div className="insight-card">
            <div className="insight-emoji">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="var(--navy)" strokeWidth="2"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
            </div>
            <h3>Git = L'eina local</h3>
            <p>Git funciona al teu ordinador. Registra canvis, crea branques, fa commits... <strong>No necessita internet</strong>. Es la base de tot.</p>
          </div>
          <div className="insight-plus">+</div>
          <div className="insight-card">
            <div className="insight-emoji">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="var(--navy)" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
            </div>
            <h3>GitHub/GitLab = El nuvol</h3>
            <p>Plataformes web on puges el teu repositori per <strong>compartir-lo</strong>, col·laborar en equip i tenir una copia de seguretat.</p>
          </div>
          <div className="insight-equals">=</div>
          <div className="insight-card result">
            <div className="insight-emoji">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="var(--gold-dark)" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            </div>
            <h3>Desenvolupament professional</h3>
            <p>Combinar Git + una plataforma es l'estandard de la industria. <strong>Cap empresa treballa sense aixo.</strong></p>
          </div>
        </div>

        {/* Analogia */}
        <div className="analogy-box">
          <h3>Analogia per entendre-ho</h3>
          <div className="analogy-items">
            <div className="analogy-item">
              <span className="analogy-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
              </span>
              <div>
                <strong>Git</strong> es com <strong>Microsoft Word</strong> amb "Control de canvis" activat.
                Guarda cada versio del document al teu ordinador.
              </div>
            </div>
            <div className="analogy-item">
              <span className="analogy-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
              </span>
              <div>
                <strong>GitHub/GitLab</strong> es com <strong>Google Drive</strong>.
                Puges els documents al nuvol perque altres persones puguin veure'ls i editar-los.
              </div>
            </div>
          </div>
        </div>

        {/* GitLab vs GitHub detail */}
        <div className="platform-detail">
          <h3>Quan utilitzar GitHub vs GitLab?</h3>
          <div className="detail-grid">
            <div className="detail-card github-card">
              <h4>Tria GitHub si...</h4>
              <ul>
                <li>Vols contribuir a projectes <strong>open source</strong></li>
                <li>Busques la <strong>comunitat mes gran</strong> de desenvolupadors</li>
                <li>Vols un <strong>portfolio public</strong> per mostrar a empreses</li>
                <li>Et sents comode amb <strong>GitHub Actions</strong> per CI/CD</li>
              </ul>
            </div>
            <div className="detail-card gitlab-card">
              <h4>Tria GitLab si...</h4>
              <ul>
                <li>Necessites <strong>CI/CD potent</strong> integrat de serie</li>
                <li>Vols un <strong>servidor propi</strong> (self-hosted) gratis</li>
                <li>Treballes en un entorn <strong>empresarial/universitat</strong></li>
                <li>Vols tot el cicle <strong>DevOps en una sola eina</strong></li>
              </ul>
            </div>
          </div>
          <div className="tip-box" style={{marginTop: '1rem'}}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            <p><strong>Per aquest curs</strong> utilitzarem principalment <strong>GitHub</strong>, pero tot el que aprenguem de Git funciona exactament igual amb GitLab. La diferencia es nomes la interficie web.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhatIsGit;
